<!-- fallow-ignore-file complexity -->
<div
	class="jepto-page-editor-tabs"
	[attr.data-testid]="testId() ?? undefined"
	[attr.role]="isMobile() ? null : 'tablist'"
	[attr.aria-label]="ariaLabel()"
>
	@if (isMobile()) {
		<div
			class="jepto-page-editor-tabs__mobile"
			[class.jepto-page-editor-tabs__mobile--view-only]="viewOnly()"
		>
			<button
				type="button"
				#mobileTrigger
				class="jepto-page-editor-tabs__mobile-trigger"
				[class.jepto-page-editor-tabs__mobile-trigger--open]="
					dropdownOpen()
				"
				[class.jepto-page-editor-tabs__mobile-trigger--view-only]="
					viewOnly()
				"
				[attr.aria-expanded]="dropdownOpen()"
				[attr.aria-haspopup]="'listbox'"
				[attr.aria-label]="ariaLabel()"
				(click)="toggleDropdown()"
			>
				@if (selectedPage(); as page) {
					<span
						class="jepto-page-editor-tabs__mobile-trigger-content"
					>
						@if (page.icon) {
							<span
								class="jepto-page-editor-tabs__mobile-trigger-icon material-symbols-outlined"
								aria-hidden="true"
								>{{ page.icon }}</span
							>
						}
						<span
							class="jepto-page-editor-tabs__mobile-trigger-text"
						>
							<span
								class="jepto-page-editor-tabs__mobile-trigger-label"
								>{{ displayLabel(page) }}</span
							>
						</span>
					</span>
				}
				<span
					class="jepto-page-editor-tabs__mobile-trigger-chevron-wrap"
				>
					<mat-icon
						class="jepto-page-editor-tabs__mobile-trigger-chevron"
						[class.jepto-page-editor-tabs__mobile-trigger-chevron--open]="
							dropdownOpen()
						"
						aria-hidden="true"
						>expand_more</mat-icon
					>
				</span>
			</button>
			@if (dropdownOpen() && panelPosition(); as pos) {
				<div
					class="jepto-page-editor-tabs__mobile-backdrop"
					(click)="closeDropdown()"
					aria-hidden="true"
				></div>
				<div
					class="jepto-page-editor-tabs__mobile-panel"
					role="listbox"
					[attr.aria-label]="ariaLabel()"
					[style.top.px]="pos.top"
					[style.left.px]="pos.left"
					[style.width.px]="pos.width"
				>
					@for (tab of tabs(); track trackByPageId($index, tab)) {
						<button
							type="button"
							class="jepto-page-editor-tabs__mobile-option"
							[class.jepto-page-editor-tabs__mobile-option--active]="
								selectedIndex() === $index
							"
							[class.jepto-page-editor-tabs__mobile-option--hidden-in-view]="
								!viewOnly() && tab.hidden
							"
							role="option"
							[attr.aria-selected]="selectedIndex() === $index"
							[attr.aria-label]="
								displayLabel(tab) +
								(tab.hidden && !viewOnly()
									? ' (hidden in view mode)'
									: '')
							"
							[attr.title]="
								!viewOnly() && tab.hidden ? 'Hidden' : null
							"
							(click)="selectPageAndClose($index)"
						>
							@if (tab.icon) {
								<span
									class="jepto-page-editor-tabs__mobile-option-icon material-symbols-outlined"
									aria-hidden="true"
									>{{ tab.icon }}</span
								>
							}
							<span
								class="jepto-page-editor-tabs__mobile-option-label"
								>{{ displayLabel(tab) }}</span
							>
							@if (selectedIndex() === $index) {
								<mat-icon
									class="jepto-page-editor-tabs__mobile-option-check"
									aria-hidden="true"
									>check</mat-icon
								>
							}
						</button>
					}
				</div>
			}
		</div>
	} @else {
		<div class="jepto-page-editor-tabs__scroll-wrap">
			@if (canScrollLeft() || canScrollRight()) {
				<button
					type="button"
					class="jepto-page-editor-tabs__scroll-btn jepto-page-editor-tabs__scroll-btn--left"
					aria-label="Scroll tabs left"
					[disabled]="!canScrollLeft()"
					(click)="scrollLeft()"
				>
					<mat-icon
						class="material-symbols-outlined"
						aria-hidden="true"
						>chevron_left</mat-icon
					>
				</button>
			}
			<div
				class="jepto-page-editor-tabs__scroll"
				#tabsScrollHost
				(scroll)="onScroll()"
			>
				<ul class="jepto-page-editor-tabs__list">
					@for (tab of tabs(); track trackByPageId($index, tab)) {
						<li
							class="jepto-page-editor-tabs__item"
							[class.jepto-page-editor-tabs__item--active]="
								selectedIndex() === $index
							"
							[class.jepto-page-editor-tabs__item--hidden-in-view]="
								!viewOnly() && tab.hidden
							"
							role="presentation"
						>
							<button
								type="button"
								class="jepto-page-editor-tabs__tab"
								role="tab"
								[attr.aria-selected]="
									selectedIndex() === $index
								"
								[attr.aria-label]="
									displayLabel(tab) +
									(tab.hidden && !viewOnly()
										? ' (hidden in view mode)'
										: '')
								"
								[attr.title]="
									!viewOnly() && tab.hidden ? 'Hidden' : null
								"
								(click)="onTabChange($index)"
							>
								@if (tab.icon) {
									<span
										class="jepto-page-editor-tabs__icon material-symbols-outlined"
										>{{ tab.icon }}</span
									>
								}
								<span class="jepto-page-editor-tabs__label">{{
									displayLabel(tab)
								}}</span>
							</button>
						</li>
					}
				</ul>
			</div>
			@if (canScrollLeft() || canScrollRight()) {
				<button
					type="button"
					class="jepto-page-editor-tabs__scroll-btn jepto-page-editor-tabs__scroll-btn--right"
					aria-label="Scroll tabs right"
					[disabled]="!canScrollRight()"
					(click)="scrollRight()"
				>
					<mat-icon
						class="material-symbols-outlined"
						aria-hidden="true"
						>chevron_right</mat-icon
					>
				</button>
			}
		</div>
	}
	<div class="jepto-page-editor-tabs__separator" aria-hidden="true"></div>
</div>
